import React from 'react';
import styled from 'styled-components';
import VMOImage from '../Assets/template/vmo.jpg';

const VMO = () => {
  return (
    <Container>
      {/* Vision Section */}
      <Wrapper>
        <Section>
          <Title>Vision</Title>
          <Text>
            To empower agricultural sectors globally by leveraging advanced digital technologies to optimize irrigation management, ensuring sustainable water usage and maximizing agricultural productivity.
          </Text>
        </Section>

        {/* Mission Section */}
        <Section>
          <Title>Mission</Title>
          <Text>
            Our mission is to implement a comprehensive and innovative assessment system that combines data-driven insights with real-time irrigation management, enabling farmers and agricultural stakeholders to improve water efficiency, reduce wastage, and enhance the overall performance of irrigation systems.
          </Text>
        </Section>

        {/* Objectives Section */}
        <Section>
          <Title>Objectives</Title>
          <ObjectiveList>
            <ObjectiveItem>Enhance Irrigation Efficiency: Utilize digital tools to assess and optimize the efficiency of irrigation systems, reducing water waste and maximizing crop yield.</ObjectiveItem>
            <ObjectiveItem>Promote Sustainability: Ensure sustainable water use by providing data-driven recommendations that align with environmental conservation goals and local agricultural practices.</ObjectiveItem>
            <ObjectiveItem>Empower Farmers with Real-Time Data: Provide farmers with real-time data and analytics on their irrigation systems, helping them make informed decisions about water usage, scheduling, and maintenance.</ObjectiveItem>
            <ObjectiveItem>Reduce Operational Costs: Implement smart technologies that reduce the need for manual intervention, lowering operational and maintenance costs for irrigation systems.</ObjectiveItem>
            <ObjectiveItem>Improve System Monitoring: Implement continuous, real-time monitoring of irrigation systems to identify inefficiencies, potential issues, and areas for improvement.</ObjectiveItem>
            <ObjectiveItem>Support Decision-Making: Equip stakeholders with actionable insights and predictive analytics, enhancing decision-making processes for irrigation planning and management.</ObjectiveItem>
            <ObjectiveItem>Facilitate Scalable Solutions: Develop a flexible platform that can be scaled across different regions, from smallholder farms to large-scale agricultural operations, catering to diverse needs and conditions.</ObjectiveItem>
            <ObjectiveItem>Foster Collaboration and Knowledge Sharing: Build partnerships with government agencies, farmers, and research institutions to promote knowledge exchange and collaborative efforts in improving irrigation systems.</ObjectiveItem>
          </ObjectiveList>
        </Section>
      </Wrapper>
    </Container>
  );
};

export default VMO;


const Container = styled.div`
  font-family: 'Arial', sans-serif;
  background-color: 'white';
  padding: 110px;
  max-width: 1200px;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(252, 244, 244, 0.1);
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px; 
`;

const Section = styled.div`
  flex: 1;
  min-width: 280px;
  max-height: 300px; 
  background-color: #ffffff;
  padding: 30px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
  background: linear-gradient(135deg,rgb(51, 148, 59) 0%, #f1faee 100%);
  overflow-y: auto;  
  scrollbar-width: thin; 
  scrollbar-color: rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.1); 
  
  &:hover {
    background-image: url(${VMOImage}); 
    background-size: cover; 
    background-position: center; 
    transform: translateY(-10px); 
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.15); 
  }
`;

const Title = styled.h2`
  font-size: 26px;
  font-weight: 600;
  color: rgb(29, 87, 55);
  margin-bottom: 20px;
  text-align: center;
  font-family: 'Roboto', sans-serif;
`;

const Text = styled.p`
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  text-align: justify;
`;

const ObjectiveList = styled.ul`
  list-style-type: none;
  padding-left: 0;
  margin-top: 20px;
`;

const ObjectiveItem = styled.li`
  font-size: 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  position: relative;

  &::before {
    content: "•";
    color: #1d3557;
    margin-right: 10px;
    font-size: 20px;
    position: absolute;
    left: -25px;
  }
`;
